import { isCsvFile } from "@utils/helpers/gcp.helper";
import { fileTypeFromBlob, fileTypeFromBuffer } from "file-type";
import HvecToJpeg from "./converters/HvecToJpeg";
import { IConverter } from "./converters/IConverter";

const conversionMap: Record<string, IConverter> = {
  "image/heif": HvecToJpeg(),
};

/**
 * fileTypeFromBlob by file-type library doesn't work on Safari, throwing an exception that ReadableStreamBYOBReader is not available.
 * This function is a workaround to fix it.
 * link: https://github.com/sindresorhus/file-type/issues/690
 */
async function readFromBlobOrBuffer(file: File) {
  let fileType;

  try {
    fileType = await fileTypeFromBlob(file);
  } catch {
    const buffer = await file.arrayBuffer();
    fileType = fileTypeFromBuffer(buffer);
  }

  return fileType;
}

// Check if the given file needs to be converted
export const fileNeedsConversion = async (file: File) => {
  if (isCsvFile(file.name)) {
    return;
  }

  const fileType = await readFromBlobOrBuffer(file);
  if (!fileType) {
    throw new Error("File type could not be detected.");
  }

  const { mime } = fileType;

  return !!conversionMap[mime];
};

// converts a file to its supported equivalent
export const convertFile = async (file: File) => {
  const fileType = await readFromBlobOrBuffer(file);
  if (!fileType) {
    throw new Error("File type could not be detected.");
  }
  const { mime } = fileType;

  // If the file does not need to be converted, return the original
  if (!conversionMap[mime]) {
    return file;
  }

  return conversionMap[mime].convert(file);
};
